import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaPrompt } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaPrompt";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { useTranslation } from "@coworker/locales";
import { FixaText } from "../../wrappers/FixaText/FixaText";
import React from "react";

interface ProductQualityErrorProps {
  openProductQualityErrorModal: boolean;
  onClose: (closeProductQualityErrorModal: boolean) => void;
}

export const ProductQualityError = ({
  openProductQualityErrorModal,
  onClose,
}: ProductQualityErrorProps) => {
  const { t } = useTranslation();
  return (
    <FixaModal
      visible={openProductQualityErrorModal}
      handleCloseBtn={() => {
        onClose(!openProductQualityErrorModal);
      }}
    >
      <FixaPrompt
        titleId="ProductQualityError"
        title=""
        header={
          <FixaModalHeader
            ariaCloseTxt={t("closeActionString")}
            title={t("noPqrTeamString")}
          />
        }
        footer={
          <FixaModalFooter>
            <FixaButton aria-label={t("okIUnderstandString")} type={"primary"}>
              {t("okIUnderstandString")}
            </FixaButton>
          </FixaModalFooter>
        }
      >
        <React.Fragment>
          <FixaText
            aria-label={t("pqrErrorModalTitleString")}
            tagName="h2"
            textStyle="Heading.S"
          >
            {t("pqrErrorModalTitleString")}
          </FixaText>
          <FixaText aria-label={t("pqrErrorModalBodyString")}>
            {t("pqrErrorModalBodyString")}
          </FixaText>
        </React.Fragment>
      </FixaPrompt>
    </FixaModal>
  );
};
